import {
  LayoutDashboard, CheckSquare, User, Building2, Calendar,
  CreditCard, FileText, ClipboardList, Clock, BarChart3,
  Paperclip, Target, PenTool, Users, Megaphone,
  BookOpen, Sun, Library, Trophy, BookMarked, ListTodo, Shield, ClipboardCheck, NotebookPen, GraduationCap
} from "lucide-react";

// ─── Fonts ────────────────────────────────────────────────────────────────────
export const FONTS = `@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=Noto+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&family=DM+Mono:wght@400;500&display=swap');`;

// ─── i18n ─────────────────────────────────────────────────────────────────────
export const T = {
  en: {
    appName: "EduPulse Defence", tagline: "Crack NDA, CDS, AFCAT with AI-Powered Prep.",
    login: "Sign In", email: "Email Address", password: "Password",
    role: "Role", forgotPwd: "Forgot password?", signing: "Signing in...",
    welcomeBack: "Welcome back, Aspirant", loginSubtitle: "Sign in to continue your preparation",
    superadmin: "Super Admin", admin: "Admin", teacher: "Mentor", student: "Aspirant", tutor: "Tutor / Mentor", individual: "Individual Aspirant",
    dashboard: "Dashboard", attendance: "Sessions", fees: "Subscription",
    announcements: "Announcements", exams: "Mock Tests", students: "Aspirants",
    staff: "Mentors", reports: "Reports", settings: "Settings",
    adminusers: "Admin Users",
    accessMgmt: "Access Management", active: "Active", revoked: "Revoked",
    name: "Full Name", phone: "Phone / WhatsApp", class: "Batch",
    cancel: "Cancel", confirm: "Confirm",
    totalStudents: "Total Aspirants", todayAttendance: "Today's Sessions",
    pendingFees: "Subscriptions Pending", papersGenerated: "Mock Tests Generated",
    classAttendance: "Batch-wise Sessions", topDefaulters: "Pending Renewals",
    logout: "Sign Out", language: "Language",
    userId: "User ID", grade: "Score", section: "Batch", actions: "Actions", status: "Status",
    viewProfile: "View Profile", studentProfile: "Aspirant Profile",
    academicInfo: "Exam Performance", attendanceHistory: "Session History",
    parentContact: "Guardian Contact", totalDue: "Amount Due",
    feeHistory: "Payment History", homework: "Practice Log", marks: "Test Records",
    catAcademic: "Top Performer", catRegular: "Regular", catDefaulter: "Subscription Due", catAttention: "Needs Attention",
    markNow: "View Now →", sendAll: "Send All Reminders", newAnn: "+ New",
    addStudent: "Add Aspirant", addTeacher: "+ Add Mentor",
    subject: "Subject", doj: "Date of Joining", assignClasses: "Assign Batches",
    absent: "Absent", present: "Present", markAbsent: "Mark Absent", markPresent: "Mark Present",
    proxyDuties: "Substitute Duties", proxyNote: "Covering for unavailable mentor",
    selfAttendance: "My Attendance", checkIn: "Check In Now", checkInSuccess: "Checked In",
    locationCaptured: "Location Captured", checkInTime: "Check-in Time",
    fetchingLocation: "Fetching location...", locationError: "Location access denied",
    curriculum: "Syllabus & Mock Tests", finishChapter: "Complete Topic", finished: "Completed",
    inProgress: "In Progress", upcomingTests: "Upcoming Mock Tests", scheduleTest: "Schedule Test",
    uploadMaterial: "Upload PDF/Excel", generateMock: "Generate AI Mock",
    fileNote: "Upload chapter PDF or question sheet to create an auto mock test",
    myStudents: "My Aspirants", assignHomework: "Assign Practice", dailyTasks: "Daily Tasks",
    selfStudy: "Self Study", addSlot: "+ Add Slot", addTask: "+ Add Task",
    myExams: "My Mock Tests", myFees: "My Subscription", myPapers: "Test Papers",
    addExam: "+ Add Test", addFee: "+ Add Payment", addPaper: "+ Add Paper",
    dailyLog: "Daily Log", teacherLogs: "Mentor Logs", addLog: "+ Add Log",
    timetable: "Schedule", mySchedule: "My Schedule",
    gradebook: "Score Tracker", examMgmt: "Mock Tests", leaveManagement: "Leave",
    studyMaterials: "Study Materials", classReports: "Reports",
    announcements2: "Announcements",
    paperMaker: "Paper Maker", assignments: "Practice Sets",
    currentAffairs: "Current Affairs", gkLibrary: "GK Library",
    ssbPrep: "SSB Preparation", allIndiaRank: "All India Rank",
    examTarget: "Target Exam", mockTests: "Mock Tests", previousPapers: "PYQ Papers",
  },
  hi: {
    appName: "EduPulse Defence", tagline: "NDA, CDS, AFCAT की तैयारी AI के साथ करें।",
    login: "साइन इन", email: "ईमेल पता", password: "पासवर्ड",
    role: "भूमिका", forgotPwd: "पासवर्ड भूल गए?", signing: "लॉग इन हो रहा है...",
    welcomeBack: "वापसी पर स्वागत है, उम्मीदवार", loginSubtitle: "तैयारी जारी रखने के लिए साइन इन करें",
    superadmin: "सुपर एडमिन", admin: "एडमिन", teacher: "मेंटर", student: "उम्मीदवार", tutor: "ट्यूटर / मेंटर", individual: "व्यक्तिगत उम्मीदवार",
    dashboard: "डैशबोर्ड", attendance: "सेशन", fees: "सब्सक्रिप्शन",
    announcements: "सूचनाएं", exams: "मॉक टेस्ट", students: "उम्मीदवार",
    staff: "मेंटर", reports: "रिपोर्ट", settings: "सेटिंग",
    accessMgmt: "एक्सेस प्रबंधन", active: "सक्रिय", revoked: "रद्द",
    name: "पूरा नाम", phone: "फ़ोन / WhatsApp", class: "बैच",
    cancel: "रद्द करें", confirm: "पुष्टि करें",
    totalStudents: "कुल उम्मीदवार", todayAttendance: "आज के सेशन",
    pendingFees: "सब्सक्रिप्शन बाकी", papersGenerated: "मॉक टेस्ट तैयार",
    classAttendance: "बैचवार सेशन", topDefaulters: "नवीनीकरण बाकी",
    logout: "साइन आउट", language: "भाषा",
    userId: "यूज़र ID", grade: "स्कोर", section: "बैच", actions: "कार्य", status: "स्थिति",
    viewProfile: "प्रोफ़ाइल देखें", studentProfile: "उम्मीदवार प्रोफ़ाइल",
    academicInfo: "परीक्षा प्रदर्शन", attendanceHistory: "सेशन इतिहास",
    parentContact: "अभिभावक संपर्क", totalDue: "कुल बकाया",
    feeHistory: "भुगतान इतिहास", homework: "अभ्यास लॉग", marks: "टेस्ट रिकॉर्ड",
    catAcademic: "शीर्ष प्रदर्शनकर्ता", catRegular: "नियमित", catDefaulter: "सब्सक्रिप्शन बाकी", catAttention: "ध्यान दें",
    markNow: "अभी देखें →", sendAll: "सभी को रिमाइंडर भेजें", newAnn: "+ नई",
    addStudent: "उम्मीदवार जोड़ें", addTeacher: "+ मेंटर जोड़ें",
    subject: "विषय", doj: "जुड़ने की तारीख", assignClasses: "बैच सौंपें",
    absent: "अनुपस्थित", present: "उपस्थित", markAbsent: "अनुपस्थित करें", markPresent: "उपस्थित करें",
    proxyDuties: "सब्स्टिट्यूट ड्यूटी", proxyNote: "अनुपस्थित मेंटर की जगह",
    selfAttendance: "मेरी उपस्थिति", checkIn: "अभी हाजिरी लगाएं", checkInSuccess: "उपस्थिति दर्ज",
    locationCaptured: "लोकेशन मिल गई", checkInTime: "हाजिरी का समय",
    fetchingLocation: "लोकेशन खोजी जा रही है...", locationError: "लोकेशन एक्सेस नहीं मिली",
    curriculum: "सिलेबस और मॉक टेस्ट", finishChapter: "टॉपिक पूरा करें", finished: "पूरा हुआ",
    inProgress: "जारी है", upcomingTests: "आगामी मॉक टेस्ट", scheduleTest: "टेस्ट शेड्यूल करें",
    uploadMaterial: "PDF/Excel अपलोड करें", generateMock: "AI मॉक बनाएं",
    fileNote: "ऑटो मॉक टेस्ट बनाने के लिए चैप्टर PDF या प्रश्न पत्र अपलोड करें",
    myStudents: "मेरे उम्मीदवार", assignHomework: "अभ्यास दें", dailyTasks: "दैनिक कार्य",
    selfStudy: "स्वयं अध्ययन", addSlot: "+ स्लॉट जोड़ें", addTask: "+ कार्य जोड़ें",
    myExams: "मेरे मॉक टेस्ट", myFees: "मेरी सब्सक्रिप्शन", myPapers: "टेस्ट पेपर",
    addExam: "+ टेस्ट जोड़ें", addFee: "+ भुगतान जोड़ें", addPaper: "+ पेपर जोड़ें",
    dailyLog: "दैनिक लॉग", teacherLogs: "मेंटर लॉग", addLog: "+ लॉग जोड़ें",
    timetable: "शेड्यूल", mySchedule: "मेरा शेड्यूल",
    gradebook: "स्कोर ट्रैकर", examMgmt: "मॉक टेस्ट", leaveManagement: "छुट्टी",
    studyMaterials: "अध्ययन सामग्री", classReports: "रिपोर्ट",
    announcements2: "सूचनाएं",
    paperMaker: "पेपर बनाएं", assignments: "अभ्यास सेट",
    currentAffairs: "करेंट अफेयर्स", gkLibrary: "GK लाइब्रेरी",
    ssbPrep: "SSB तैयारी", allIndiaRank: "अखिल भारतीय रैंक",
    examTarget: "लक्ष्य परीक्षा", mockTests: "मॉक टेस्ट", previousPapers: "पिछले वर्ष के प्रश्न",
  },
};

// ─── Domain List Fallbacks ────────────────────────────────────────────────────
// Prefer useSchoolConfig(user) which loads these dynamically from the DB.
// These are kept only as fallbacks when school config is not yet loaded.
export const SUBJECTS = [
  "Mathematics", "English", "General Knowledge", "General Science",
  "Current Affairs", "Reasoning & Intelligence", "History", "Geography",
  "Polity", "Physics", "Chemistry", "Biology",
];

export const DEFENCE_EXAMS = ["NDA", "CDS", "AFCAT", "CAPF", "Territorial Army", "MNS", "SSB"];

export const EXAM_TYPES = ["Section Test", "Full Mock Test", "Previous Year Paper", "Speed Test", "SSB Practice"];

export const CLASS_LIST = [
  "NDA Batch A", "NDA Batch B", "CDS Batch A", "CDS Batch B",
  "AFCAT Batch", "CAPF Batch", "SSB Batch", "Foundation Batch",
];

// ─── Nav Item Definitions (per role) ─────────────────────────────────────────
export const buildNavItems = (t) => ({
  admin: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "students",      ico: User,            lbl: t.students },
    { id: "staff",         ico: Building2,       lbl: t.staff },
    { id: "exams",         ico: Target,          lbl: t.exams },
    { id: "fees",          ico: CreditCard,      lbl: t.fees },
    { id: "feestructures", ico: FileText,        lbl: "Subscription Plans" },
    { id: "teacherlogs",   ico: ClipboardList,   lbl: t.teacherLogs },
    { id: "announcements", ico: Megaphone,       lbl: t.announcements },
    { id: "reports",       ico: BarChart3,       lbl: t.reports },
  ],
  saas_admin: [
    { id: "superadmin",   ico: Shield,          lbl: t.saasadmin || "SaaS Admin" },
    { id: "adminusers",   ico: Users,           lbl: t.adminusers },
  ],
  teacher: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "myschedule",    ico: Calendar,        lbl: t.mySchedule },
    { id: "assignments",   ico: Paperclip,       lbl: t.assignments },
    { id: "exams",         ico: Target,          lbl: t.examMgmt },
    { id: "gradebook",     ico: PenTool,         lbl: t.gradebook },
    { id: "papermaker",    ico: FileText,        lbl: t.paperMaker },
    { id: "students",      ico: Users,           lbl: t.students },
    { id: "dailylog",      ico: ClipboardList,   lbl: t.dailyLog },
    { id: "announcements", ico: Megaphone,       lbl: t.announcements2 },
    { id: "materials",     ico: BookOpen,        lbl: t.studyMaterials },
    { id: "reports",       ico: BarChart3,       lbl: t.classReports },
    { id: "leave",         ico: Sun,             lbl: t.leaveManagement },
  ],
  student: [
    { id: "dashboard",      ico: LayoutDashboard, lbl: t.dashboard },
    { id: "currentaffairs", ico: BookOpen,        lbl: t.currentAffairs || "Current Affairs" },
    { id: "gklibrary",      ico: Library,         lbl: t.gkLibrary || "GK Library" },
    { id: "exams",          ico: Target,          lbl: t.mockTests || "Mock Tests" },
    { id: "papers",         ico: FileText,        lbl: t.previousPapers || "PYQ Papers" },
    { id: "leaderboard",    ico: Trophy,          lbl: "All India Rank" },
    { id: "materials",      ico: Library,         lbl: t.studyMaterials },
    { id: "reportcard",     ico: BarChart3,       lbl: "My Performance" },
    { id: "announcements",  ico: Megaphone,       lbl: t.announcements2 },
    { id: "fees",           ico: CreditCard,      lbl: t.myFees },
  ],
  coordinator: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "students",      ico: Users,           lbl: t.students },
    { id: "staff",         ico: Building2,       lbl: t.staff },
    { id: "reports",       ico: BarChart3,       lbl: t.reports },
  ],
  tutor: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "students",      ico: Users,           lbl: t.myStudents },
    { id: "assignments",   ico: PenTool,         lbl: t.assignments },
    { id: "exams",         ico: Target,          lbl: t.examMgmt },
  ],
  individual: [
    { id: "dashboard",      ico: LayoutDashboard, lbl: t.dashboard },
    { id: "currentaffairs", ico: BookOpen,        lbl: t.currentAffairs || "Current Affairs" },
    { id: "gklibrary",      ico: Library,         lbl: t.gkLibrary || "GK Library" },
    { id: "exams",          ico: BarChart3,       lbl: t.myExams },
    { id: "papers",         ico: FileText,        lbl: t.myPapers },
    { id: "selfstudy",      ico: BookMarked,      lbl: t.selfStudy },
    { id: "tasks",          ico: ListTodo,        lbl: t.dailyTasks },
    { id: "prephub",        ico: NotebookPen,     lbl: "Prep Hub" },
    { id: "syllabus",       ico: GraduationCap,   lbl: "Syllabus" },
    { id: "fees",           ico: CreditCard,      lbl: t.myFees },
  ],
  parent: [
    { id: "dashboard",   ico: LayoutDashboard, lbl: "Dashboard"    },
    { id: "marks",       ico: BarChart3,       lbl: "Performance"  },
    { id: "assignments", ico: Paperclip,       lbl: "Practice Sets"},
  ],
});
